import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setVoxAuthDialogVisible } from '../../features/dialogControl/dialogControlSlice';
import { graphqlRequest} from '../../services/graphql-service';
import { GET_ALL_ARTISTS} from '../../config/queries.js';
import ArtistPreview from '../artist-preview/artist-preview';
import './artists.css';
import Footer from '../footer/footer';
import { motion } from 'framer-motion';


const Artists = () => {
    const [artistsData, setArtistsData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isBlurred, setIsBlurred] = useState(true);
    const dispatch = useDispatch();

    useEffect(() => {
        const user = JSON.parse(localStorage.getItem('mb-auth'));
        if (user) {
                setIsBlurred(false);
        } else {
            setIsBlurred(true);
            dispatch(setVoxAuthDialogVisible(true)); 
        }
    }, [dispatch]);
    

    useEffect(() => {
        const fetchArtistsData = async () => {
            try {
                setLoading(true);
                const data = await graphqlRequest(GET_ALL_ARTISTS, {}); // Replace with your variables
                setArtistsData(data.artists);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };
        
        fetchArtistsData();
    }, []);
    
    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error}</p>;
    
    return (
        <div>
            {isBlurred && <div className="blurred-overlay"></div>}

            <div className="artists-container content-block-radial-background">
                <div className='artist-list-banner'>Artists</div>
                <div className='artist-list-container'>
                    {artistsData.map((a, index) => {
                        return (
                            <motion.div
                                initial={{ opacity: 0, x: "100px" }}  // Start fully off-screen to the right
                                animate={{ opacity: 1, x: 0 }}  // Slide into view
                                transition={{ duration: 0.75, ease: "backOut", delay: (index) * 0.10 }} 
                                key={index} 
                            >
                                <ArtistPreview key={a.id} artist={a} bg={index % 2 === 0 ? 'even' : 'odd'}/>
                            </motion.div>
                        )
                    })}
                </div>
            </div>
            <Footer />
        </div>
      );
}

export default Artists;